import { GenericEntityData } from "../models/genericEntityData";
import { IParseGenericEntityData } from "./IParseGenericEntityData";
import { ITypedPagedResult } from '../models/pagedResult';
import { Injectable } from '@angular/core';
import { IdentityData } from "../models/identityData";
import { GenericPropertyDataCollection } from "../models/genericPropertyDataCollection";
import { GenericPropertyData } from "../models/genericPropertyData";

@Injectable({
  providedIn: 'root'
})

export class ParseGenericEntityData implements IParseGenericEntityData {
  private multiGenericEntityStorage: Array<ITypedPagedResult<GenericEntityData>> = [];
  private singleGenericEntityStorage: Array<GenericEntityData> = [];

  parseData<T>(data: any, type: {new() :T}, entityName?: string): any {
    

    //only multi instance tables with have the Items Property
    if (data.Items === undefined) {
      //single instance
      if (entityName) {//Stores the table name used to grab the raw data.
        this.singleGenericEntityStorage[entityName] = data;
      }
      return ParseGenericEntityData.parseSingleData(data, type);
    }
    else {
      if (entityName) {//Stores the table name used to grab the raw data.
        this.multiGenericEntityStorage[entityName] = data;
      }
      return ParseGenericEntityData.parseMultiData(data, type);
    }
    
  }

  static parseMultiData<T>(data: ITypedPagedResult<GenericEntityData>, type: {new(): T}): T[] {
    var result = Array<T>();

    for (let i = 0; i < data.Items.$values.length; i++) {
      const currentValue = data.Items.$values[i];
      var parsedObj = new type();

      for (let y = 0; y < currentValue.Properties.$values.length; y++) {
        const currentProperty = currentValue.Properties.$values[y];
        parsedObj[currentProperty.Name] = currentProperty.Value;
      }

      result[i] = parsedObj;
    }

    return result;

  }

  static parseSingleData<T>(data: GenericEntityData, type: { new(): T }): T {
    var result = new type();

      for (let y = 0; y < data.Properties.$values.length; y++) {
        const currentProperty = data.Properties.$values[y];
        result[currentProperty.Name] = currentProperty.Value;
      }

    return result;
  }

  //TODO: finish writing and testing, based on the updateSingleGenericEntityData
  updateMultiGenericEntityData(data: any, entityName: string): ITypedPagedResult<GenericEntityData> {
    let entities = [];
    let entity = [];

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        entity[key] = data[key];
      }
    }

    entities.push(entity);

    var genericEntityData: ITypedPagedResult<GenericEntityData> = this.multiGenericEntityStorage[entityName];

    for (let i = 0; i < entities.length; i++) {
      //for (let key in Object.keys(entities[i])) {
      for (let key in entities[i]) {
        for (let k = 0; k < genericEntityData.Items.$values[i].Properties.$values.length; k++) {
          if (genericEntityData.Items.$values[i].Properties.$values[k].Name === key) {
            //if (entities[i][key]) {
            genericEntityData.Items.$values[i].Properties.$values[k].Value = entities[i][key];
            //}
          }
        }
      }
    }
    return genericEntityData;
  }

  updateSingleGenericEntityData(data: any, entityName: string): GenericEntityData {

    let entity = [];

    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        entity[key] = data[key];
      }
    }

    var genericEntityData = new GenericEntityData();

    //build base entity info
    genericEntityData.EntityTypeName = entityName;

    var identyData = new IdentityData();
    identyData.EntityTypeName = entityName;
    identyData.IdentityElements.$values.push(data.ID);

    genericEntityData.Identity = identyData;

    var identyPartyData = new IdentityData();
    identyPartyData.EntityTypeName = "Party";
    identyPartyData.IdentityElements.$values.push(data.ID);
    genericEntityData.PrimaryParentIdentity = identyPartyData;

    genericEntityData.Properties = new GenericPropertyDataCollection();


    //for (let key in Object.keys(entities[i])) {
    for (let key in entity) {

      //make sure the ID exists for both properties
      if (key === "ID") {
        var prop = new GenericPropertyData();
        prop.Name = "PartyId";
        prop.Value = entity[key];

        genericEntityData.Properties.$values.push(prop);
      }

      var prop = new GenericPropertyData();
      prop.Name = key;
      prop.Value = entity[key];

      genericEntityData.Properties.$values.push(prop);
      
    }

    return genericEntityData;
  }
}
